import React, { useState } from 'react';
import { useDispatch } from 'react-redux';

import { addToCart } from '../redux/actions';
import { Button, ProductModal } from '.';
import { formatCurrency } from '../utils';

export default function Products({ products }) {
  const [openProdModal, setOpenProdModal] = useState(false);
  const [modalProduct, setModalProduct] = useState(null);
  const dispatch = useDispatch();

  const showProductModal = (e, product) => {
    e.preventDefault();
    setOpenProdModal(true);
    setModalProduct(product);
  };

  return (
    <>
      <div className="mt-6 grid grid-cols-1 gap-y-10 gap-x-6 sm:grid-cols-2 lg:grid-cols-4 xl:gap-x-8">
        {products?.map((product) => (
          <div key={product._id} className="group relative">
            <div className="w-full min-h-80 bg-white aspect-w-1 aspect-h-1 rounded-md overflow-hidden group-hover:opacity-75 md:h-80 lg:aspect-none">
              <a
                href="#"
                onClick={(e) => showProductModal(e, product)}
                className="h-full flex items-center"
              >
                <img
                  src={product.imageSrc}
                  alt={product.name}
                  className="w-full h-full object-contain lg:w-full lg:h-60"
                />
              </a>
            </div>
            <div className="mt-4 flex justify-between">
              <div>
                <h3 className="text-sm text-gray-700">
                  <span aria-hidden="true" className="" />
                  {product.name}
                </h3>
              </div>
              <p className="text-sm font-medium text-gray-900">
                {formatCurrency(product.price)}
              </p>
            </div>
            <div className="text-right mt-4">
              <Button
                label="Add to Cart"
                handleClick={() => dispatch(addToCart(product))}
              />
            </div>
          </div>
        ))}
      </div>
      {openProdModal && modalProduct && (
        <ProductModal
          open={openProdModal}
          setOpen={setOpenProdModal}
          product={modalProduct}
        ></ProductModal>
      )}
    </>
  );
}
